import { UPSERT_LOCATION } from './upsertLocation';
import { GET_PARTNER_LINK } from './getPartnerLink';
import { LINK_NEW_PARTNER } from './linkNewPartner';
import { GET_PARTNER_LINKS } from './getPartnerLinks';
import { GET_DEALER_ACCOUNT } from './getDealerAccount';
import { GET_PARTNERS_PROPOSALS } from './getPartnersProposals';
import { GET_PARTNER_LINK_METRICS } from './getPartnerLinkMetrics';
import { GET_PARTNER_LINKS_LIGHTWEIGHT } from './getPartnerLinksLightweight';
import { PARTNER_PROFILE_PROPOSAL_METRICS } from './getPartnerProposalMetrics';
import { GET_PARTNERS_PROPOSALS_WITH_PAGINATION } from './getPartnersProposalsWithPagination';
import { GET_PARTNERS_OWN_PROPOSALS_WITH_PAGINATION } from './getPartnersOwnProposalsWithPagination';
import { CREATE_PARTNER_ACCOUNT } from './createPartnerAccount';

export const aftermarketPartnerApi = {
  getPartnerLink: GET_PARTNER_LINK,
  getPartnerLinks: GET_PARTNER_LINKS,
  getDealerAccount: GET_DEALER_ACCOUNT,
  getPartnersProposals: GET_PARTNERS_PROPOSALS,
  getPartnerLinkMetrics: GET_PARTNER_LINK_METRICS,
  getLinksLightweight: GET_PARTNER_LINKS_LIGHTWEIGHT,
  partnerProfileProposalMetrics: PARTNER_PROFILE_PROPOSAL_METRICS,
  getPartnersProposalsWithPagination: GET_PARTNERS_PROPOSALS_WITH_PAGINATION,
  getPartnersOwnProposalsWithPagination: GET_PARTNERS_OWN_PROPOSALS_WITH_PAGINATION,

  upsertLocation: UPSERT_LOCATION,
  linkNewPartner: LINK_NEW_PARTNER,
  createPartnerAccount: CREATE_PARTNER_ACCOUNT,
};

export * from './usePartner';
